import { useState } from 'react';
import { Link } from 'react-router-dom';
import * as style from '../utils/general_style.js';
import * as links from '../utils/general_links.js';
import { questionsAnswers } from '../utils/question_faq';
import CTABlock from '../components/global/CTABlock.jsx';
import CTAButton from '../components/global/CTAButton.jsx';
import QuelquesChiffres from '../components/quisommesnous/QuelquesChiffres.jsx';
import CarteFrance from '../components/quisommesnous/CarteFrance.jsx';
import Response from '../components/faq/Response.jsx';
import img1 from '../assets/image_2.png';
import AnimatedImage from '../assets/animated_image1.mp4';

function HomePage() {
    const [clicked, setClicked] = useState('0');
    const handleToggle = (index) => {
        if (clicked === index) {
            return setClicked('0');
        }
        setClicked(index);
    };

    const ctaBlockTitle = ['Vous vendez un terrain ?', 'Vous construisez une maison ?']
    const avantages = [
        `D'accéder à un réseau d'experts dans toute la France`,
        'De réaliser des projets à des tarifs abordables',
        `D'optimiser vos projets (temps, coûts, qualité)`
    ];

	return (
        <>
            <div className="AppBody">
                <section style={{...style.ROW_SPACE_BETWEEN}}>
                    {ctaBlockTitle.map((title, index) => (
                        <CTABlock title={ title } key={ index } />
                    ))}
                </section>
                <section style={{...style.COLUMN_CENTER, ...style.ELEMENT_BLOCK_GREY}}>
                    <h2>Choisir <span style={style.PRESENTIS}>Presentis</span> pour vos besoins :</h2>
                    <article style={style.ROW_SPACE_BETWEEN}>
                        <div style={{width: '34%', height: '100%', overflow: 'hidden'}}>
                            <img src={img1} alt={'hommes regardant une tablette'} />
                        </div>
                        <div className="paragraph" style={{...style.COLUMN_CENTER, width: '63%', alignItems: 'start'}}>
                            <p>C'est choisir une plateforme qui va vous permettre de réaliser vos projets en bénéficiant des avantages suivants :</p>
                            {avantages.map((avantage, index) => (
                                <p key={ index }>&emsp; &#9656; { avantage }</p>
                            ))}
                        </div>
                    </article>
                    <hr style={{width: '50%', margin: `${style.SPACE.medium} 0`}} color={style.COLORS.grey} size={'1'} />
                    <h2>En quelques chiffres</h2>
                    <QuelquesChiffres />
                </section>
                <section style={style.ELEMENT_BLOCK_WHITE}>
                    <video autoPlay loop muted>
                        <source src={AnimatedImage} />
                    </video>
                </section>
                <section style={style.ELEMENT_BLOCK_GREY}>
                    <h2>Nos investigations d'étude de sol réalisées</h2>
                    <CarteFrance />
                </section>
                <section style={{...style.ELEMENT_BLOCK_WHITE, ...style.COLUMN_CENTER}}>
                    <h2>Vous avez des questions ?</h2>
                    <p style={{marginBottom: style.SPACE.small}}>Questions générales</p>
                    <div style={{width: '100%'}}>
                        {questionsAnswers
                            .filter((question) => question.homepage)
                            .map(({ question, answer}, index) => {
                                return <Response question={ question } answer={ answer } key={index} onToggle={() => handleToggle(index)} isActive={clicked === index} />
                            })
                        }
                    </div>
                    <div style={{width: '100%'}}>
                        <Link to={links.ROUTES.faq} style={style.INLINE_LINK}>Voir les autres questions du FAQ...</Link>
                    </div>
                    <hr style={{width: '50%', margin: `${style.SPACE.medium} 0`}} color={style.COLORS.grey} size={'1'} />
                    <p style={{marginBottom: style.SPACE.medium}}>Un autre renseignement ?</p>
                    <CTAButton label='Demande de contact' route={links.ROUTES.contact} />
                </section>
            </div>
        </>
	);
};

export default HomePage;